import React from 'react';
import { ClaimStatus } from "../models/Claim";

/** Custom properties for ClaimStatusBadge component
 * Can be consumed by the parent element
 */
type ClaimStatusBadgeProps = {
    status: ClaimStatus | undefined
}

const ClaimStatusBadge = ({ status }: ClaimStatusBadgeProps) => {

    /**
     * Renders JSX.Element that represents the current claim status.
     * @returns JSX Element that represents status.
     */
    function renderStatusBadge(): React.JSX.Element {
        switch (status) {
            case ClaimStatus.Saved:
                return <span className="badge bg-primary badge-lg"><i className="bi bi-hdd me-2"></i>Saved</span>
            case ClaimStatus.Requested:
                return <span className="badge bg-primary badge-lg"><i className="bi bi-arrow-repeat me-2"></i>Requested</span>
            case ClaimStatus.ApprovalRun:
                return <span className="badge bg-dark badge-lg"><i className="bi bi-arrow-repeat me-2"></i>In approval run</span>
            case ClaimStatus.Paid:
                return <span className="badge bg-success badge-lg"><i className="bi bi-check-circle me-2"></i>Paid</span>
            case ClaimStatus.Rejected:
                return <span className="badge bg-danger badge-lg"><i className="bi bi-x-circle me-2"></i>Rejected</span>
            case ClaimStatus.Deleted:
                return <span className="badge bg-danger badge-lg"><i className="bi bi-trash me-2"></i>Deleted</span>
            // Some unknown status ... Most likley because claim is null ....
            default:
                return <span className="badge bg-light badge-lg"><i className="bi bi-question me-2"></i>Unkown</span>
        }
    }

    return (
        <>
            {renderStatusBadge()}
        </>
    )

}
export default ClaimStatusBadge;